import type {IntentProfileRecord} from '../lib/catalog';

type Props={
  profile:IntentProfileRecord|null;
  agents:number;
  tools:number;
  realtimeStatus:string;
  databaseStatus:string;
};

export default function ContextMatrix({
  profile,
  agents,
  tools,
  realtimeStatus,
  databaseStatus,
}:Props){
  return (
    <aside className="context-panel glass-panel">
      <div className="panel-label">CONTEXT MATRIX</div>
      <div className="context-row"><span>INTENT</span><strong>{profile?.label??'UNRESOLVED'}</strong></div>
      <div className="context-row"><span>ROUTED AGENTS</span><strong>{profile?agents:'—'}</strong></div>
      <div className="context-row"><span>ROUTED TOOLS</span><strong>{profile?tools:'—'}</strong></div>
      <div className="context-row"><span>APPROVAL</span><strong className={profile?.approval_mode==='required'?'context-amber':''}>{profile?.approval_mode.toUpperCase()??'—'}</strong></div>
      <div className="context-row"><span>DATABASE</span><strong>{databaseStatus}</strong></div>
      <div className="context-row"><span>REALTIME</span><strong>{realtimeStatus}</strong></div>
      <div className="context-foot">STATE SOURCE // SUPABASE + LOCAL ORCHESTRATION SIMULATOR</div>
    </aside>
  );
}
